import Vue from 'vue'
import Component from 'vue-class-component'

@Component
export default class GlobalMixin extends Vue {
    track(action: string, category = '', eventLabel = '', value = '') {
        if (process.env.VUE_APP_PRODUCTION !== 'true') {
            console.log('Tracking: ',action, category, eventLabel, value);
        }
        this.$gtag.event(action, {
            category,
            eventLabel,
            value
        })
    }
}
